// Affiliate image redirect for Machismo Plus product pages
// Intercepts product gallery image clicks and redirects to affiliate URL
// when the product has a custom.external_url metafield set.

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const productInfo = document.querySelector('product-info[data-affiliate-url]');
    if (!productInfo) return;

    const affiliateUrl = productInfo.getAttribute('data-affiliate-url');
    if (!affiliateUrl || affiliateUrl.trim() === '') return;

    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    const modalOpeners = gallery.querySelectorAll('.product__modal-opener--image');

    modalOpeners.forEach(function (opener) {
      opener.style.cursor = 'pointer';

      opener.addEventListener('mouseenter', function () {
        opener.style.opacity = '0.88';
        opener.style.transition = 'opacity 0.2s ease';
      });
      opener.addEventListener('mouseleave', function () {
        opener.style.opacity = '1';
      });

      opener.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(affiliateUrl, '_blank', 'noopener,noreferrer');
      }, true);
    });

    const zoomButtons = gallery.querySelectorAll('.product__media-zoom-lightbox');
    zoomButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(affiliateUrl, '_blank', 'noopener,noreferrer');
      }, true);
    });
  });
})();